import React, { useState, useEffect } from "react";
import axios from "axios";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";

import '../Dashboard.css';
import classes from "./Payments.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

function Payments() {
    const [orders, setOrders] = useState([]);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    const config = {
        params: {
            uid: logged_user,
            pname: 'wesharez'
        },
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }

    const FetchOrders = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/payments.php`, null, config)
            .then(res => {
                console.log(res.data);
                setOrders(res.data);
            }).catch(err => {
                console.log(err);
            })
    }

    useEffect(() => {
        FetchOrders();
    }, [])

    console.log(orders);
  return (
    <>
        <Helmet>
            <title>Payments</title>
        </Helmet>
        <div className="container_wrapper">
            <Header />
            <div className={`${styles.main} main`}>
                <Sidebar active="payments" />
                <div className={styles.main_content}>
                    <div className={styles.content_body}>
                        <div className={`${styles.title} mb-3`}>
                            <h5><i className="fa-solid fa-cart-plus"></i> Balance</h5>
                        </div>
                        <div className={`${styles.card} mb-5`}>
                            <div className={`card-body ${classes.card_body}`}>
                                <div className={classes.item_wrap}>
                                    <div className={classes.balance}>
                                        <h3 align="center">Current Balance</h3>
                                        <h4 align="center">$0.00</h4>
                                    </div>
                                    <div className={classes.card_group}>
                                        <div className="">
                                            <h5 className="text-muted">Total Earning</h5>
                                            <h6>$0.00</h6>
                                        </div>
                                        <div className="">
                                            <h5 className="text-muted">Referral Balance</h5>
                                            <h6 className="mb-0">$0.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>`   `
        </div>
    </>
  );
}

export default Payments;